import React from 'react';
import { BottomSheet } from './BottomSheet';
import { Copy, CheckCircle, Link } from 'lucide-react';

export const ShareFallbackModal = ({ isOpen, onClose, shareData }) => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = async () => {
        if (navigator.clipboard && shareData?.url) {
            try {
                await navigator.clipboard.writeText(shareData.url);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch (error) {
                console.error('Failed to copy:', error);
            }
        }
    };

    return (
        <BottomSheet isOpen={isOpen} onClose={onClose} maxWidth="md">
            <BottomSheet.Header>
                <div>
                    <BottomSheet.Title>Share Link</BottomSheet.Title>
                    <BottomSheet.Subtitle>Link copied to clipboard</BottomSheet.Subtitle>
                </div>
            </BottomSheet.Header>

            <BottomSheet.Content>
                <div className="space-y-4">
                    <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-xl border border-blue-100">
                        <Link className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
                        <div className="flex-1 min-w-0">
                            <p className="text-sm text-blue-800 font-medium">
                                You can now paste this link to share with others via Messages, WhatsApp, or any other app.
                            </p>
                        </div>
                    </div>

                    <div className="space-y-3">
                        <div>
                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                Title
                            </label>
                            <div className="p-3 bg-gray-50 rounded-lg border">
                                <p className="text-gray-900">{shareData?.title}</p>
                            </div>
                        </div>

                        <div>
                            <label className="text-sm font-medium text-gray-700 block mb-2">
                                Link
                            </label>
                            <div className="flex gap-2">
                                <div className="flex-1 p-3 bg-gray-50 rounded-lg border break-all">
                                    <input
                                        type="text"
                                        value={shareData?.url || ''}
                                        readOnly
                                        onFocus={(e) => e.target.select()}
                                        className="
                                            w-full
                                            p-3
                                            text-sm
                                            text-blue-600
                                            bg-gray-50
                                            border
                                            rounded-lg
                                            select-text
                                            cursor-text
                                        "
                                    />
                                </div>
                                <button
                                    onClick={handleCopy}
                                    className="px-4 py-3 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors flex items-center gap-2 shrink-0"
                                >
                                    {copied ? (
                                        <>
                                            <CheckCircle className="w-4 h-4 text-green-600" />
                                            <span className="text-green-600 font-medium">Copied!</span>
                                        </>
                                    ) : (
                                        <>
                                            <Copy className="w-4 h-4 text-gray-600" />
                                            <span className="text-gray-700 font-medium">Copy</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </BottomSheet.Content>

            <BottomSheet.Footer>
                <BottomSheet.CloseButton variant="primary">
                    Got it
                </BottomSheet.CloseButton>
            </BottomSheet.Footer>
        </BottomSheet>
    );
};
